import { render, staticRenderFns } from "./ChatDialogOverlays.vue?vue&type=template&id=25a8a062"
import script from "./ChatDialogOverlays.vue?vue&type=script&lang=js"
export * from "./ChatDialogOverlays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports